import { Dialog } from "@earned/core";
import Widget from "@modules/mx/components/Widget";
import { MxWidgetType } from "@modules/mx/types";

const ConnectionsWidgetDialog = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title="Connections"
      size="lg"
      classNames={{
        Description: "pl-4 h-[calc(100vh-215px)]",
      }}
    >
      <Widget widgetType={MxWidgetType.connections_widget} />
    </Dialog>
  );
};

export default ConnectionsWidgetDialog;
